import React, { useState, useContext } from 'react';
import Collapse from 'react-bootstrap/lib/Collapse';
import CollapseButton from '../CollapseButton';
import MatchingManufacturersForArticle from '../MatchingManufacturersForArticle';
import CartRepository from '../CartRepository.js';
import ListItemImage from './ListItemImage';
import Article from './Article';
import { TranslationContext, SettingsContext } from "../Context";
import DefaultListItemImage from './DefaultListItemImage';
import MatchingOEMNumbersForArticle from '../MatchingOEMNumbersForArticle';

function ProductListItem(props) {

    const [detailOpen, setDetailOpen] = useState(false);
    const [oemNumbersOpen, setOEMNumbersOpen] = useState(false);
    const [matchingVehiclesOpen, setMatchingVehiclesOpen] = useState(false);
    const [quantity, setQuantity] = useState(1);
    const translation = useContext(TranslationContext);
    const settings = useContext(SettingsContext);
    const formatter = new Intl.NumberFormat(settings.language, { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });

    function toggleAccordionItem(name) {

        switch (name) {
            case "productDetail":
                setOEMNumbersOpen(false);
                setMatchingVehiclesOpen(false);
                setDetailOpen(!detailOpen);
                break;

            case "oemNumbers":
                setMatchingVehiclesOpen(false);
                setDetailOpen(false);
                setOEMNumbersOpen(!oemNumbersOpen);
                break;

            case "matchingVehicles":
                setMatchingVehiclesOpen(!matchingVehiclesOpen);
                setDetailOpen(false);
                setOEMNumbersOpen(false);
                break;

            default:
                break;
        }
    }

    function handleQuantityChange(e) {
        let qty = Number.parseInt(e.target.value);
        if (!Number.isInteger(qty) || qty < 1) {
            qty = 1;
        }
        setQuantity(qty);
    }

    function handleAddToCartButtonClick(e){
        const repo = new CartRepository();
        repo.add(props.article.articleNumber, props.article.genericArticles[0].legacyArticleId, quantity);
    }

    function getPrice() {
        const article = props.article;
        if (article && article.prices && article.prices.length > 0) {
            var price = props.article.prices[0].priceCents / 100;
            return formatter.format(price) + ' ' + props.article.prices[0].currencyCode;
        }
        return '';
    }
    function getDiscontinued() {
        const article = props.article;
        if (article && article.isDiscontinued) {
            return true;
        }
        return false;
    }
    
    const imageComponent = function () {
        const image = props.article.images && props.article.images[0];

        if (image) {
            return <ListItemImage articleNumber={props.article.articleNumber} imageThumbUrl={image.imageUrl200} imageUrl={image.imageUrl800} alt={image.typeDescription} />;
        }
        else {
            return <DefaultListItemImage />;
        }
    }

    const price = getPrice();
    const isDiscontinued = getDiscontinued();

    return (
        <li className="vehicleProductListComponent-item">

            <div id="accordionGroup" role="tablist" aria-multiselectable="true">

                <div className="vehicleProductListComponent-itemInner">

                    {imageComponent()}

                    <div className="vehicleProductListComponent-articleInfo">

                        <Article articleNumber={props.article.articleNumber} replacedByArticles={props.article.replacedByArticles} />

                        <div className="vehicleProductListComponent-prices">
                            <div className="u-textSemi24">
                                {price}
                            </div>
                            <div className="vehicleProductListComponent-pricesMsrp u-textRegular14">{price && translation["TecAlliencePartSearch.Shared.MSRP"]}</div>
                        </div>

                        {
                            isDiscontinued ?
                                <div className="vehicleProductListComponent-discontinued">
                                    {translation["TecAlliencePartSearch.ProductList.ItemList.ItemIsDiscontinued"]}
                                </div>
                            :
                                <>
                                    <div className="vehicleProductListComponent-amount">
                                        <input className="vehicleProductListComponent-input form-control input-lg text-center" min="1" type="number" value={quantity} onChange={handleQuantityChange} />
                                    </div>

                                    <div className="vehicleProductListComponent-submit">
                                        <button className="vehicleProductListComponent-submitBtn btn btn-primary" onClick={handleAddToCartButtonClick}>{translation["TecAlliencePartSearch.ProductList.ItemList.AddToCart"]}</button>
                                    </div>
                                </>
                        }

                        <ul className="vehicleProductListComponent-accList">
                            <li className="vehicleProductListComponent-accListItem">
                                <CollapseButton className="vehicleProductListComponent-accListItemLink" open={detailOpen} onClick={(e) => toggleAccordionItem("productDetail")}>{translation["TecAlliencePartSearch.ProductList.ItemList.ProductDetails"]}</CollapseButton>
                            </li>
                            <li className="vehicleProductListComponent-accListItem">
                                <CollapseButton className="vehicleProductListComponent-accListItemLink" open={oemNumbersOpen} onClick={(e) => toggleAccordionItem("oemNumbers")}>{translation["TecAlliencePartSearch.ProductList.ItemList.OENumbers"]}</CollapseButton>
                            </li>
                            <li className="vehicleProductListComponent-accListItem">
                                <CollapseButton className="vehicleProductListComponent-accListItemLink" open={matchingVehiclesOpen} onClick={(e) => toggleAccordionItem("matchingVehicles")}>{translation["TecAlliencePartSearch.ProductList.ItemList.MatchingVehicles"]}</CollapseButton>
                            </li>
                        </ul>

                    </div>
                </div>

                <Collapse in={detailOpen}>
                    <div id="productDetails" className="panel-collapse">
                        <div className="vehicleProductListComponent-panelBody">
                            <div className="u-textSemi16 u-block u-absBottomMarginSm">{translation["TecAlliencePartSearch.ProductList.ItemList.ProductDetails"]}</div>
                            {props.article.articleCriteria.map(detail => {
                                return <div key={detail.criteriaId} className="vehicleProductListComponent-boxRow">
                                    <div className="vehicleProductListComponent-boxTitle">{detail.criteriaDescription}</div>
                                    <div className="vehicleProductListComponent-boxDesc">{detail.formattedValue}</div>
                                </div>
                            })}
                        </div>
                    </div>
                </Collapse>

                <Collapse in={oemNumbersOpen}>
                    <div id="oeNumbers" className="panel-collapse">
                        <MatchingOEMNumbersForArticle items={props.article.oemNumbers} />
                    </div>
                </Collapse>

                <Collapse in={matchingVehiclesOpen}>
                    <div id="matchingVehicles" className="panel-collapse" >
                        <MatchingManufacturersForArticle linkingTargetType={props.linkingTargetType} open={matchingVehiclesOpen} legacyArticleId={props.article.genericArticles[0].legacyArticleId} />
                    </div>
                </Collapse>
            </div>
        </li>
    );
}

export default ProductListItem;